import React from 'react'
import { isArray } from 'lodash-es'
import { showFiledValue } from '@ow/ditto-core'

const RefText = function ({ value, defs }) {
  const { refTbdefs, findDataSlug } = defs
  const { fields = [] } = refTbdefs || {}

  if (isArray(value)) {
    return (
      <>
        {value.map((item) => {
          return (
            <div
              key={item}
              style={{
                background: 'var(--ow-color-neutral-100)',
                borderRadius: '4px',
                padding: '2px 8px',
              }}
            >
              <span>{showFiledValue(item, fields, findDataSlug)}</span>
            </div>
          )
        })}
      </>
    )
  }

  return <span>{showFiledValue(value, fields, findDataSlug)}</span>
}

export default RefText
